import { LEAVE_TYPE_DAYS } from '../constants/leave';

import type { LeaveType } from '../types/leave';

/** Today as `yyyy-mm-dd`. */
export const todayIso = (): string => new Date().toISOString().slice(0, 10);

/** Format a `Date` as a `yyyy-mm-dd` local calendar date. */
export const dateToIso = (date: Date): string => {
  const y = date.getFullYear();
  const m = `${date.getMonth() + 1}`.padStart(2, '0');
  const d = `${date.getDate()}`.padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/**
 * Leave-day cost: `annual` is the inclusive day span (start..end),
 * every other type is its fixed per-type cost.
 */
export const computeLeaveDays = (
  type: LeaveType,
  startDate: string,
  endDate?: string,
): number => {
  if (type !== 'annual') {
    return LEAVE_TYPE_DAYS[type];
  }
  const end = endDate ?? startDate;
  const ms =
    Date.parse(`${end}T00:00:00Z`) - Date.parse(`${startDate}T00:00:00Z`);
  return Math.floor(ms / 86_400_000) + 1;
};

/** `yyyy-mm-dd` → `M월 D일` (year omitted; matches the home hero date). */
const toKoreanDate = (iso: string): string => {
  const [, m, d] = iso.split('-');
  return `${Number(m)}월 ${Number(d)}일`;
};

/** `M월 D일 ~ M월 D일` for a multi-day span, otherwise just `M월 D일`. */
export const formatLeaveRange = (
  startDate: string,
  endDate?: string,
): string =>
  endDate && endDate !== startDate
    ? `${toKoreanDate(startDate)} ~ ${toKoreanDate(endDate)}`
    : toKoreanDate(startDate);
